<template>
  <a-modal v-model="modal" title="物料变更" width="90%" :maskClosable="false" :closable="true" :destroyOnClose="true">
    <a-form-model ref="baseForm" class="baseForm" :model="formData">
      <ls-metable
        class="materialChangeTable"
        :columns="columns"
        :data-list="formData.infos"
        :scroll="{y:400, x:1200}"
        :customRow="(record, index) => index"
        rowKey="key_id"
        size="middle"
        :loading="tableLoading"
        :IsEdit="false"
        :needAdd="false"
        :pagination="false"
      >
        <!--变更后的物料编码-->
        <span slot="changedItemCodeTitle">
                <i class="toRequired">*</i>变更后的物料编码
              </span>
        <template slot="changedItemCode" slot-scope="{text,record,index}">
          <a-form-model-item
            :prop="`infos.${index}.changedItemCode`"
            :rules="{
                    'required':true,
                    'message':' ',
                    'trigger':'change'}" >
            <global-select
              v-model="record.changedItemCode"
              :focusGet="true"
              selectType="selectSearch"
              :dropdown-match-select-width="false"
              requestApi="/scp/scpMrpSystemItems/planItemsBoxNew"
              :selectItem="{ value: 'selectedValue', label: 'label', thirdLabel: 'selectedValue' }"
              :setParams="{ organizationCode: 'A001' }"
              searchParam="label"
              sourseField="res"
              :totalNum="9999999999"
              @change="(val, list) => itemCodeChangeFun(val, list, index)"
            />
          </a-form-model-item>
        </template>
        <!--变更后用量-->
        <span slot="changedQuantityPerAssemblyTitle">
                <i class="toRequired">*</i>变更后用量
              </span>
        <template slot="changedQuantityPerAssembly" slot-scope="{text,record,index}">
          <a-form-model-item
            :prop="`infos.${index}.changedQuantityPerAssembly`"
            :rules="{
                    'required':true,
                    'message':' ',
                    'trigger':'blur'}" >
            <a-input-number
              v-model="record.changedQuantityPerAssembly"
              :min="0.01"
              :max="999999"
              :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
              :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')" />
          </a-form-model-item>
        </template>
        <!--变更原因-->
        <span slot="changeReasonTitle">
                <i class="toRequired">*</i>变更原因
              </span>
        <template slot="changeReasonCode" slot-scope="{text,record,index}">
          <a-form-model-item
            :prop="`infos.${index}.changeReasonCode`" :rules="{
                    'required':true,
                    'message':' ',
                    'trigger':'change'}">
            <global-select
              :value.sync="record.changeReasonCode"
              selectType="selectFilter"
              :selectData="changeReasonList"
              :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              @change="(val, list) => changeReasonChangeFun(val, list, index)"
            />
          </a-form-model-item>
        </template>
        <!--备注-->
        <template slot="remarks" slot-scope="{text,record,index}">
          <a-form-model-item :prop="`infos.${index}.remarks`">
            <a-input type="textarea" :autoSize="{minRows:2}" v-model="record.remarks" :maxLength="100" />
          </a-form-model-item>
        </template>
      </ls-metable>
    </a-form-model>
    <template #footer>
      <a-space>
        <a-button @click="onClose">取消</a-button>
        <a-button type="primary" @click="submit" v-hasPermi="['mes:mesDiscreteJobsCc:submitChangeItem']" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import {
  apiCcGetMaterialInfoByRequirementIds,
  apiCcSubmitChangeItem
} from '@/api/mes/workOrderManage/ticketsManageCc'
import cacheRequest from '@/mixins/cacheRequest'

export default {
  name: 'MaterialChangeModal',
  data() {
    return {
      modal: false,
      modalType: '',
      formData: { infos: [] },
      changeReasonList: [],
      tableLoading: false, // table加载
      loading: false,
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      columns: [
        { title: '工单号', dataIndex: 'wipEntityName', width: 110, align: 'center' },
        { title: '物料编码', dataIndex: 'itemCode', width: 100, align: 'center' },
        { title: '规格描述', dataIndex: 'specification', width: 120, ellipsis: true, align: 'center' },
        { title: '物料名称', dataIndex: 'itemName', width: 120, align: 'center' },
        { title: 'BOM用量', dataIndex: 'quantityPerAssembly', width: 80, align: 'center' },
        {
          // title: '变更后的物料编码',
          dataIndex: 'changedItemCode',
          scopedSlots: { customRender: 'changedItemCode', title: "changedItemCodeTitle" },
          width: 120,
          align: 'center'
        },
        { title: '变更后的物料名称', dataIndex: 'changedItemName', width: 100, align: 'center' },
        { title: '变更后规格描述', dataIndex: 'changedSpecification', width: 120, align: 'center', ellipsis: true },
        {
          // title: '变更后用量',
          dataIndex: 'changedQuantityPerAssembly',
          scopedSlots: { customRender: 'changedQuantityPerAssembly', title: "changedQuantityPerAssemblyTitle" },
          width: 90,
          align: 'center'
        },
        {
          // title: '变更原因',
          dataIndex: 'changeReasonCode',
          scopedSlots: { customRender: 'changeReasonCode', title: "changeReasonTitle" },
          width: 85,
          align: 'center'
        },
        { title: '备注', dataIndex: 'remarks', width: 100, scopedSlots: { customRender: 'remarks' }, align: 'center' }
      ]
    }
  },
  mixins: [cacheRequest],
  methods: {
    // 物料编码变化
    itemCodeChangeFun(val, list, index) {
      if(val && list?.length > 0) {
        const getItem = list.find(item => item.selectedValue === val)
        this.$set(this.formData.infos[index], 'changedItemName', getItem?.bringOutDataOne || '')
        this.$set(this.formData.infos[index], 'changedSpecification', getItem?.bringOutDataTwo || '')
      } else {
        this.$set(this.formData.infos[index], 'changedItemName', '')
        this.$set(this.formData.infos[index], 'changedSpecification', '')
      }
    },
    // 变更原因
    changeReasonChangeFun(val, list, index) {
      if(val && list?.length > 0) {
        const getItem = list.find(item => item.lookupCode === val)
        this.$set(this.formData.infos[index], 'changeReason', getItem?.lookupValue || '')
      } else {
        this.$set(this.formData.infos[index], 'changeReason', '')
      }
    },
    show(selectData) {
      console.log(selectData)
      this.getData(selectData)
      this.cacheLookupRequest('MES_CHANGE_ITEM_REASON', { lookupType: 'MES_CHANGE_ITEM_REASON', current: 1, pageSize: 999 }, 'changeReasonList')
      this.modal = true
    },
    onClose() {
      this.$set(this.formData, 'info', [])
      this.loading = false;
      this.modal = false
    },
    // 获取数据
    getData(selectData) {
      this.$set(this.formData, 'info', [])
      this.loading = true;
      apiCcGetMaterialInfoByRequirementIds(selectData.map(v => v.id)).then(res => {
        if (res?.code === 200 && res?.data?.length > 0) {
          this.$set(this.formData, 'infos', res.data)
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    // 提交
    submit() {
      this.$nextTick(() => {
        this.$refs.baseForm.validate(valid => {
          if (valid) {
            this.loading = true;
            apiCcSubmitChangeItem(this.formData.infos).then(res => {
              if (res?.code === 200) {
                this.$message.success('操作成功')
                this.onClose()
                this.$emit('successCall')
              } else {
                this.$message.error(res?.msg)
              }
            }).finally(() => {
              this.loading = false;
            })
          }
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.materialChangeTable{
  /deep/ .ant-form-item{
    margin-bottom: 0;
  }
  /deep/ .ant-form-explain, .ant-form-extra{
    min-height: 0;
    height: 0;
  }
}
</style>
